import * as React from 'react';
import { IgcButtonGroupComponent as Component } from 'igniteui-webcomponents';
import type { IgcButtonGroupComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * The `igc-button-group` groups a series of `igc-toggle-button`s together, exposing features such as layout and selection.
 * @slot  - Renders `igc-toggle-button` component.
 * @fires igcSelect - Emitted when a button is selected through user interaction.
 * @fires igcDeselect - Emitted when a button is deselected through user interaction.
 * @csspart group - The button group container.
 * @class
 */
export const IgrButtonGroup = /* @__PURE__ */ createComponent({
  tagName: 'igc-button-group',
  displayName: 'IgrButtonGroup',
  elementClass: Component,
  react: React,
  events: {
    onSelect: 'igcSelect' as EventName<
      IgcButtonGroupComponentEventMap['igcSelect']
    >,
    onDeselect: 'igcDeselect' as EventName<
      IgcButtonGroupComponentEventMap['igcDeselect']
    >,
  },
});

export type IgrButtonGroup = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrButtonGroupModule = Component;
